import React, { useState } from "react";
import Button from "./Button";

const ContactForm = ({ para }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    designation: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const payload = {
      sheet: "thrive", // Hardcoded value
      name: formData.name,
      email: formData.email,
      company: formData.company,
      designation: formData.designation,
      subject: formData.subject,
      message: formData.message,
    };

    fetch("https://zbpje4azgliercmqvfqkh34bqm0mlmwm.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("⚠️ An error occurred. Please try again later.");
      })
      .finally(() => {
        setIsSubmitting(false);
        alert("✅ Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          company: "",
          designation: "",
          subject: "",
          message: "",
        });
      });
  };

  return (
    <div className="bg-accent p-4 sm:p-6">
      <section className="max-w-2xl mx-auto p-3 sm:p-4 bg-light rounded-lg shadow-md">
        <p className="text-base sm:text-lg font-medium text-primary mb-3 text-center">
          {para}
        </p>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="p-2 text-sm border rounded-md w-full focus:ring-2 focus:ring-primary outline-none"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="p-2 text-sm border rounded-md w-full focus:ring-2 focus:ring-primary outline-none"
              required
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input
              type="text"
              name="company"
              placeholder="Company"
              value={formData.company}
              onChange={handleChange}
              className="p-2 text-sm border rounded-md w-full focus:ring-2 focus:ring-primary outline-none"
              required
            />
            <input
              type="text"
              name="designation"
              placeholder="Designation"
              value={formData.designation}
              onChange={handleChange}
              className="p-2 text-sm border rounded-md w-full focus:ring-2 focus:ring-primary outline-none"
              required
            />
          </div>
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
            className="p-2 text-sm border rounded-md w-full focus:ring-2 focus:ring-primary outline-none"
            required
          />
          <textarea
            name="message"
            placeholder="Message"
            rows="3"
            value={formData.message}
            onChange={handleChange}
            className="p-2 text-sm border rounded-md w-full focus:ring-2 focus:ring-primary outline-none"
            required
          ></textarea>
          <div className="text-center">
            <Button text="Submit" type="submit" variant="primary" size="sm" disabled={isSubmitting} />
          </div>
        </form>
      </section>
    </div>
  );
};

export default ContactForm;
